module.exports = __webpack_public_path__ + "f827f246f1b3879313968c3f46ceedbc.pdf";